import styled from "styled-components"
import { responsive } from "../../common/styledHelpers"

// KAN-4851 revisit
export const PAGE_TOP_MARGIN = "83px"

export const Page = styled.div`
${responsive("margin-top", "83px", "80px")};
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  justify-content: center;
`

export const BreadCrumbContainer = styled.div`
  width: 100%;
  max-width: 1240px;
  display: flex;
  flex-direction: column;
  align-self: center;
  padding: 0 20px;
`

export const Content = styled.div`
  width: 100%;
  height: 100%;
  max-width: 600px;
  display: flex;
  flex-direction: column;
  align-self: center;
`



// WEBPACK FOOTER //
// ./assets/payment/components/Page.js